import * as Loadable from 'react-loadable'

import ModalLoading from '../modalLoading'

export default (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "signInModal" */ './signInContainer'),
  loading: ModalLoading,
  webpack: () => [require.resolveWeak('./signInContainer')],
  modules: ['./signInContainer']
})
